var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoHeadGreen = function SvgLogoHeadGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 26,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-head-green_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M8.168 17.388v.437l-.827-.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "M8.168 17.388v-.764l-.515.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.168 17.389-.827-.055.312-.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.943 16.561.398.772.312-.686z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.943 16.561.398.772-.608-.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.944 16.561-.539.062.328.671zM6.132 17.295l.273-.671.328.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.132 17.295.273-.671-.81.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m7.138 17.731.203-.398.827.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m7.443 18.44.725.063v-.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m7.138 17.732.203-.398-.608-.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m7.138 17.732-.686.054.28-.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.132 17.295.32.491.28-.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m6.132 17.295.32.491-.421.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.132 17.295-.819.171.718.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m5.415 18.012-.102-.546.718.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m5.415 18.012-.102-.546-.32.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m5.415 18.012-.234.624-.187-.694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.191 18.995-.748-.554-.219.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.191 18.995-.748-.554.725.062zM6.71 18.332l.733.11-.219.436z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m6.71 18.332-.406-.086.366.507.554.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m5.766 18.332.366-.18.172.094.367.507-.367-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M8.168 18.503v-.678l.257.023.36.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.767 18.27.374-.102v-.241l-1.716-.078.36.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.738 17.365-.57.023v-.764l.53.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.737 17.365.523-.11-.039-.631-.523.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m8.168 16.624.53.5.523-.5zM8.168 16.624l1.014-.609.04.608z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.168 16.624 1.014-.609-.047-.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.712 16.624-.452.632-.039-.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m9.713 16.624-.453.632.492-.024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m9.713 16.624.42.055-.381.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m10.243 17.255-.11-.577-.382.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m10.243 17.255-.11-.577.78.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m10.243 17.255.811.164-.14-.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m11.475 17.185-.421.234-.14-.57"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m11.475 17.185.21-.733-.771.398"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m10.914 16.85.772-.398-.874-.101z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m10.914 16.85-.102-.5-.717-.078.039.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m9.712 16.624-.054-.46.437.109.039.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m9.713 16.624-.055-.46-.476-.149.04.608zM9.135 15.813l.265-.063.843-.242-.585.656-.476-.149z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m10.243 15.508-.585.656.437.109z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m10.243 15.508.57.843-.718-.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m10.243 15.509.57.842.608-1.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m11.686 16.452-.874-.101.609-1.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "M9.712 15.001s.04.328-.085.46c-.125.125-.234.258-.234.289s.842-.234.842-.234l-.53-.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    fillOpacity: 0.333,
    d: "m10.243 15.509-.53-.507.67-.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m10.243 15.509 1.178-.203-1.038-.53zM11.015 14.486l.406.82-1.038-.531z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m11.015 14.486.406.82-.086-1.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m11.015 14.486-.335-.592.655.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m11.015 14.486-.335-.592-.297.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m10.095 14.034.585-.14-.297.881z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m10.095 14.034-.624.328.912.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m10.095 14.034-.624.328.202-.913z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m10.095 14.034.585-.14-1.007-.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m9.549 12.91 1.13.983-1.006-.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m9.923 13.238.757.655.218-.717zM11.335 14.112l-.655-.219.218-.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m11.335 14.112.203-.998-.64.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m11.335 14.112.203-.998.694 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m10.414 12.084-.296.5.78.592.078-.772z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m10.976 12.404.562.71-.64.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m10.976 12.404.562.71.28-.546zM10.976 12.404l.6-.187.242.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m12.029 12.077-.452.14.241.351.601.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m12.029 12.076.304-.14h.585l-.5.741zM12.598 13.777l-1.06-.663.28-.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m12.598 13.777-.179-1.1-.6-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m13.628 12.833-.359 1.186-.148-.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m12.598 13.777.671.241-.148-.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m12.598 13.777-.179-1.1.702.359z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m12.918 11.936.71.897-.507.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m13.846 12.116-.039.857-.18-.14-.077-.803z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m13.846 12.116-.039.858.04.343.28-.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m13.846 12.115-.039-.905-.397.328.14.491z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m12.918 11.936.71.897-.078-.803z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m12.918 11.936.492-.398.14.492z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m12.918 11.936.492-.397-.539-.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m12.918 11.936-.421-.234.374-.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m12.918 11.936-.421-.234-.164.234zM12.598 13.777l-1.06-.663.694 1.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m9.923 13.239.195-.655.78.592z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m10.414 12.084-.296.5-.78-.617.757-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m9.923 13.239.195-.655-.78-.617.21.944z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m8.823 11.406.515.561.335 1.482z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m9.104 12.958.265.717.304-.226z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m9.104 12.958-.101-.554.67 1.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.823 11.406.18.998.67 1.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m9.47 14.362.242.64.671-.227z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.206 14.315.507.686-.437-.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m9.37 14.011-.165.304-.429-.366.593-.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m9.37 14.01.1.352.203-.913-.304.226z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m9.104 12.958-.218-.554-.11-.57.047-.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m8.73 13.215.046.733.593-.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m8.73 13.215.046.733-.64-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "m8.152 14.338.624-.39-.64-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m8.152 14.338.624-.39.047.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m9.205 14.315-.429-.367.047.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m9.205 14.315.07.491-.452-.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m8.823 15.11.453-.304-.453-.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m8.823 15.11-.67-.218.67-.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "M8.152 14.338v.554l.671-.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M8.152 14.338v.554l-.608-.187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m7.567 15.204.585-.312-.608-.187zM8.152 14.338l-.608-.304v.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.152 14.338-.608-.304.593-.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m7.567 13.27-.023.764.593-.476z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m7.567 13.27.546-.476.024.764z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m7.567 13.27.546-.476-.507-.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.051 12.084.062.71-.507-.242z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.051 12.085-.413-.312-.032.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m8.051 12.084.062.71.5-.351z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m8.051 12.085.406-.312.156.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.051 12.085.406-.312-.406-.305zM8.051 12.085l-.413-.312.413-.305zM8.73 13.215l.374-.258.265.718z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.73 13.216.374-.258-.491-.515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m8.886 12.404.218.554-.491-.515"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.73 13.216-.616-.422.499-.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m8.73 13.215-.617-.421.024.764"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m7.544 14.705-.562.343.585.156zM8.152 14.892l-.585.312.617.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m6.982 15.048-.358.125.553.53.078-.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m6.624 15.173.553.522s-.117.117-.35-.085c-.227-.203-.196-.398-.203-.437M7.255 15.508s.29-.187.562.047c.039.047.367-.101.367-.101l-.609-.25-.593-.156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "M7.544 10.984s.133.453.101.788l-.452-.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    fillOpacity: 0.067,
    d: "M7.544 10.984s.133.453.101.788l.414-.304v-.39l-.507-.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m7.544 10.984-.374-.023.023.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m7.544 10.984-.374-.023.101-.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m6.64 10.79.53.17.101-.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.64 10.79-.445-.71 1.076.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.64 10.79-.445-.71-.695.202z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m4.572 10.43.414-.546.515.398zM4.572 10.43l-.187-.608-.468.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.572 10.43-.25.367-.405-.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m3.59 10.813.733-.016-.406-.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m3.59 10.813.234.593-.297.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m4.572 10.43-.25.367.718-.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m5.43 10.961-.468.11-.64-.274.718-.078z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m4.682 11.203.28-.133-.64-.273-.303.28zM4.682 11.203l-.453.203h-.405l.195-.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m4.323 10.797-.733.015.234.593.195-.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m4.572 10.43.468.29.46-.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m7.193 11.445-2.153-.726.46-.436zM7.193 11.445l-2.153-.726.39.242zM6.64 10.79l.553.655-1.692-1.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.64 10.79.53.171.023.484zM4.253 11.546l-.258.234.39.172.094-.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m5.095 11.78-.023.304-.687-.133.094-.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m5.095 11.78-.023.304.53.023-.187-.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.962 12.716.11-.632.53.023.304.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.962 12.716.11-.632.53.023.304.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.962 12.716.11-.632-.687-.132-.226.553z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.962 12.716-.14 1.178-.663-1.389z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m5.836 11.803.491.359-.725-.055-.187-.304zM5.43 9.378l.913-.655.39.928zM8.137 9.94 6.343 8.722l.39.928zM5.43 9.377l.913-.655-.842-.538z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151D28",
    d: "m6.234 7.537.109 1.186-.843-.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.234 7.537-.944-1.56.21 2.207z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.79 7.459.5-1.482.21 2.207z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.79 7.459.5-1.482-.476-.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.234 7.537.109 1.185L8.05 7.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M6.234 7.537 8.012 5.15l.04 2.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M6.234 7.537 8.012 5.15l-1.934.195zM6.234 7.537l-.57-1.817.414-.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.234 7.537-.57-1.817-.374.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m6.023 4.502 1.989.648-1.934.195z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.023 4.503 1.989.647-.062-1.942z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.023 4.502-.593.562.648.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.023 4.502-.593.562-1.177-.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.023 4.503.055-1.116-1.825 1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m6.023 4.503.055-1.116 1.872-.179z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m5.43 2.841.648.546-1.825 1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m5.43 2.842.648.546.296-.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "m7.95 3.209-1.872.18.296-.921zM7.95 3.208l.062-1.248-1.638.507zM8.028 1.671l-.016.289-1.638.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M8.028 1.671 6.14 2.07l.234.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "m5.851 2.366.29-.297.233.398z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m5.852 2.365-.422.476.944-.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m6.14 2.07-.71.772.094-.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m5.43 2.841-1.279.671.102 1.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m3.457 4.635.694-1.123.102 1.155zM4.814 5.43l.616-.366-.413-.14-.764-.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m5.664 5.72-.234-.656.648.281z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m5.664 5.72-.234-.656-.616.367.476.546z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "M8.137 9.94 6.343 8.721 8.05 7.396z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.137 9.94 1.396-1.381-1.482-1.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.993 7.537-.46 1.022-1.482-1.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "M9.993 7.537 8.013 5.15l.038 2.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "M9.993 7.537 8.013 5.15l1.816.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m9.86 4.713-1.848.437 1.817.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m9.86 4.713-1.848.437-.062-1.942zM9.86 4.713l-.07-1.326-1.84-.179z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "m9.627 2.459.163.928-1.84-.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.627 2.459.163.928.539-.335z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.627 2.459 1.021.406-.32.187z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "m9.627 2.46 1.021.405-.46-.702zM9.627 2.46l-1.615-.5-.062 1.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m9.627 2.46-1.615-.5.016-.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "m9.627 2.46.257-.445-1.856-.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.627 2.46.257-.445.304.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m9.86 4.713-.07-1.326 1.802 1.147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m10.649 2.865-.858.522 1.801 1.147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m10.649 2.865 1.193.632-.25 1.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m12.832 5.29-.99-1.793-.25 1.037z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m12.832 5.29-.99-1.793 1.217 1.216z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m12.832 5.29.546.75-.32-1.327z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m12.832 5.291.546.749-.18.507z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m12.832 5.291-.234 1.256h.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m13.144 7.467-.546-.92h.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m13.144 7.467-.546-.92-.312.873z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m13.144 7.467-.429.663-.429-.71zM13.144 7.467l-.429.663.515.67zM12.817 8.91l-.102-.78.515.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m11.842 7.396.873.734-.429-.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m11.842 7.396.873.734-.366.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m11.842 7.396-1.116.804 1.623.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m11.842 7.396-1.116.804-.733-.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m10.102 9.386.624-1.186-.733-.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m10.102 9.386-.569-.827.46-1.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m10.102 9.386-.569-.827-.226 1.108z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m8.137 9.94 1.396-1.38-.226 1.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m12.895 9.463-.18-1.334-.366.702z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m12.895 9.463-.273.351-.273-.982z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m11.343 9.635 1.279.18-.273-.983zM11.343 9.635 10.726 8.2l1.623.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "M11.343 9.635 10.726 8.2l-.624 1.185z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m11.842 7.397.078-.476.678-.375-.312.874zM13.714 7.31l-.336-1.27-.18.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m13.714 7.31-.57.157.055-.92zM13.714 7.31l-.57.157.398 1.248zM13.714 7.31l.163 1.132-.335.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151D28",
    d: "m13.714 9.636.163-1.194-.335.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m13.714 9.635-.367.18L13.23 8.8l.312-.086z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "M12.95 9.814h.397L13.23 8.8l-.405.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m13.714 9.636.164-1.194.296.765z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m14.174 8.34-.296.102.296.764zM13.714 7.31l.164 1.132.117-1.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m14.174 8.34-.296.102.117-1.326h.14zM13.23 8.8l-.086-1.333.398 1.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m13.378 6.04-.32-1.327.57 1.326z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m13.378 6.04.336 1.27.28-.195-.366-1.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m13.651 5.438.484 1.677h-.14l-.367-1.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m12.481 3.746-.64-.25 1.218 1.217-.156-.608z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.031,
    d: "m13.807 11.21.07-.834.297-1.17V8.34l-.039-1.225-.484-1.677"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m13.651 5.44-.023.6-.57-1.326-.155-.609z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "M12.832 5.29H11.28l.312-.756z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M11.982 5.291h-.702l1.318 1.256zM11.92 6.921l-.64-1.63 1.318 1.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m11.92 6.921-.64-1.63-1.287 2.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m11.92 6.92-.078.477-1.849.14zM11.982 5.291h.85l-.234 1.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m10.648 2.865 1.194.632-1.654-1.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "m10.976 2.537.866.96-1.654-1.334z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m10.976 2.537.866.96-.18-.632z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m12.482 3.746-.64-.25-.18-.631z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.86 4.714 1.42.577.312-.757z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m9.86 4.713 1.42.578-1.45.748zM9.993 7.537l1.287-2.246-1.45.749z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M5.524 2.304 4.15 3.513l1.28-.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m3.995 3.208.156.305 1.373-1.21s-1.1.586-1.529.905"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "M3.27 3.949s.476-.562.725-.741l.156.304zM2.638 5.01l-.585 1.497.53-.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m2.482 6.796-.429-.289.53-.452z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m2.482 6.796-.429-.289-.078.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m2.482 6.796-.39 1.084-.117-.803z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m2.482 6.796-.39 1.084.343-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m2.201 8.558-.109-.678.343-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m2.201 8.558.632.04-.398-.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m2.201 8.56.632.038-.515.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M1.975 7.077s-.14 1.138-.023 2.074l.14-1.271zM1.952 9.152l.21 1.513.04-2.106zM2.591 10.595l-.429.07.04-2.106z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m2.591 10.595.156.522.382-.483zM2.591 10.594l.304-.795.234.834z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m2.591 10.594.304-.795-.577-.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m3.122 9.276-.227.523-.577-.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m3.122 9.277-.289-.679-.515.554z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m2.591 10.595-.429.07.04 1.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m2.591 10.595.156.522-.546.757z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M2.747 12.396v-1.279l-.546.757zM2.747 12.397l-.374 1.162-.172-1.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m2.115 12.334.258 1.225-.172-1.685z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m2.115 12.334-.195-.913.281.453zM2.521 13.106l-.148.452.374.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m2.521 13.106.6.39-.374.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m3.324 14.775-.202-1.279-.375.32zM2.521 13.106l.6.39-.374-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m2.474 14.073-.101-.515.374.258zM2.474 14.073l1.014 1.981-.74-2.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m2.747 14.799-.686-.367-.125.398c.133.164.655 0 .655 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M2.591 14.83s-.522.163-.655 0c0 0 .133.374.733.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m2.474 14.073 1.014 1.981-.795-.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m3.044 17.294.444-1.24-.795-.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m3.044 17.294.444-1.24.063 1.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.112 16.39-.624-.336.063 1.077z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.112 16.39-.624-.335-.164-1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m2.747 13.816.741 2.238-.164-1.279zM4.112 16.39l-.031-1.685-.757.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.112 16.39-.031-1.685.663 1.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.994 15.002-.913-.297.663 1.763zM4.112 16.39l.117 1.942-.678-1.201z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m4.112 16.39.117 1.942.226-.351.289-1.513z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.994 17.942-.539.038.289-1.513zM4.994 17.942l-.539.039.726.655z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.884 18.956-.429-.976.726.656zM4.884 18.956l.43.367-.133-.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m5.766 19.143-.453.18-.132-.687zM5.766 19.143l-.453.18.53.764zM5.766 19.143l.42.328-.342.616zM4.884 18.956l-.429-.976-.226.351zM4.994 17.942l.32-1.475h-.57zM4.994 17.942l.32-1.475v.999z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "M5.313 17.466v-.999l.281.305zM5.313 17.466l.82-.171-.539-.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m3.044 17.294.413.827.094-.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m4.23 18.332-.773-.211.094-.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m5.212 19.751-.328-.795.43.366zM5.212 19.752l.632.335-.53-.764z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m5.212 19.752.632.335-.047.304zM6.397 20.649l-.553-.562-.047.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.398 20.649-.554-.562.608.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.398 20.649.53-.102-.476-.413z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.397 20.649.53-.102-.085.468z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m6.826 21.195-.132.171-.913-.718.016-.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m6.397 20.648-.039.258.468.288.016-.179z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.397 20.649-.039.257-.577-.258.016-.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m7.599 20.922-.671-.375.67-.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m7.599 20.922-.671-.375-.086.468z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M7.599 20.921v.312l-.757-.218zM7.599 20.922l.538-.219v.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "M7.599 20.921v.312l.538-.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.137 21.452-.538-.219.538-.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.137 21.452-.538-.219-.757-.218 1.295.523zM8.137 21.725l-1.31-.53.015-.18 1.295.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m8.137 21.725-1.31-.53-.133.17 1.443.578zM6.912 21.943l.281-.374-.5-.203-.155.203z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.912 21.944.281-.375.944.375v.257l-.452.055z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m1.952 9.152.14-1.272.11.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "M8.168 19.167v.358l-.632-.109.32-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m7.536 19.416-.023.554.655-.445zM8.168 20.025l-.655-.054.655-.445z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.168 20.025.998-.117-.998-.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m8.168 19.167.998.74-.998-.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m8.168 19.166.998.741.297-.951z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85FFB6",
    d: "m9.775 19.938-.609-.03.297-.952z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m8.706 20.469-.538-.445.5-.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m8.706 20.469.46-.562-.499.063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m8.706 20.469.46-.562.25.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m9.775 19.938-.608-.03.25.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m9.775 19.938.359-.616-.671-.366z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m10.048 18.738.086.585-.671-.367z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "m10.048 18.738.086.585.32-.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m10.812 19.666-.678-.343.32-.328z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m10.812 19.666.492-.453-.85-.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m11.054 18.504.25.71-.85-.219zM10.812 19.666l-.53.71-.031-.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m10.812 19.666-.678-.343.117.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m9.775 19.939.359-.616.117.483z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m9.775 19.938.507.437-.031-.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.581 10.922-.124.85-.406-.304v-.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m8.581 10.922-.124.85.32.063.046-.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m8.613 12.443-.156-.67.32.062.109.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m8.581 10.922.305-.288-.75-.695-.085 1.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m8.886 10.634-.75-.694 1.17-.274z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m4.962 12.716.75.647.194-.928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m4.962 12.716.75.647-.212.5-.678.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.429 13.27-.718.094.718-.734z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.429 13.27-.718.093-.21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.429 12.63-.718.734.195-.928.421-.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m5.602 12.108.725.054-.42.273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "M5.766 18.332v.811l.538-.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M5.766 18.332v.312l-.585-.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m5.766 18.332-.351-.32-.234.624z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m5.766 18.332-.351-.32.616-.101zM5.766 19.143v-.499l-.585-.008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m4.23 18.332.654.624h-.561z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m5.212 19.751-.328-.795h-.561z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m8.137 22.2-.453.055.453.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.866 22.497.818-.242.453.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "M8.121 23.487v.43l-.975-.118z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m8.121 23.488-.928-.476-.047.787zM8.121 23.487l-.928-.475.944-.086zM6.866 22.497l.327.514.944-.085z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.865 22.497.328.515-1.123-.671.078-.172z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.569 23.067.624-.055-1.123-.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.866 22.497.818-.242-.772-.312z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m6.865 22.497-.468-.608.515.054z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m6.865 22.497-.468-.608-.25.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m6.538 21.57-.14.32.514.054zM2.607 22.006l.538.046.148-1.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m3.55 21.655-.405.397.148-1.146z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m3.55 21.654-.093-1.42-.164.672z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m3.55 21.654-.093-1.42.39.032z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "m12.98 22.022-.312-.226-.132-2.107z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m12.98 22.022.234-.57-.678-1.763z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m12.98 22.021.234-.57.313.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M1.936 14.83s-.156-.234-.172-.46-.023-.234-.046-.297c-.024-.062-.063-.21-.063-.21l.078-.031s.11.483.18.522l.14.078-.125.398zM1.25 11.344l-.172-.102c0 .11.039.476.094.811L1.296 12c-.023-.336-.039-.648-.039-.648z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "M1.367 12.63a6 6 0 0 1-.078-.64l-.125.055c.031.25.07.484.086.578.039.234.405 1.232.405 1.232l.078-.031s-.288-.812-.366-1.201zM1.07 11.242s.07-.53.187-.445.422.36.656.624l.046.203-.71-.273-.171-.109z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M2.747 12.443a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M14.51 11.062l.397-.257s-.335-.335-.67.023z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m14.236 10.828-.429.382.016.328.686-.468s.024-.421-.273-.234z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m13.846 13.317-.039.569.445-.148-.125-.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m14.51 12.942-.258.796-.125-.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m14.51 12.942.148-.663-.53.484z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m14.51 12.942.148-.663.273.063-.149.725z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m14.51 12.942-.258.796.148.125.382-.796z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m14.182 14.611.07-.873.148.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m14.182 14.611.07-.873-.445.148z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m14.182 14.611-.18.265-.242-.39.047-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "m13.846 14.978.156-.102-.242-.39-.085.492z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m3.122 9.276.663.523M3.122 9.276l.803-.585"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m3.176 8.559.897-.702"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m3.176 8.56-.054.717"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m2.591 10.594-.273-1.443"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m2.895 9.799-.577-.648M2.833 8.598l-.515.554"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m2.318 9.151.804.125"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m2.833 8.598.289.679M2.833 8.598l.14-.718M3.176 8.559l-.203-.679M3.504 7.537l-.53.343M3.223 6.952l-.25.928M3.223 6.952l-.788.819M2.927 6.555 2.435 7.77M2.927 6.555l-.445.241M2.927 6.554l.53-.413M2.927 6.554l.218-.951M2.583 6.055l.562-.452M3.761 5.37l-.616.233M3.761 5.368l.492-.702M3.761 5.369l-.304-.733M3.098 4.714l.359-.078M3.098 4.713l.172-.764M2.638 5.01l.632-1.061M4.79 7.46l-.717.397M4.12 6.68l-.047 1.177M4.79 7.46l-.865 1.232M4.79 7.46l-.374 1.77M4.385 9.822l.031-.593M4.986 9.885l-.57-.656"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.385 9.822.6.063"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.43 9.378-.444.507M5.43 9.378l.07.905M4.79 7.46l.71.725M4.79 7.459l.024-2.028M5.29 5.977l.21 2.207M5.29 5.977l.944 1.56M8.012 5.15 6.234 7.537"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.664 5.72.57 1.817"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.29 5.977-.476-.546"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m3.785 9.799.14-1.108M4.822 13.894l-.741.81M4.744 16.468l-.663-1.763"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.744 16.468-.632-.078"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M4.744 16.467h.57M5.594 16.772l-.28-.305M4.994 17.942l.32-1.475M4.744 16.467l.25 1.475M4.994 15.001l.32 1.466M4.994 15.001l.85 1.35M5.711 15.033l.133 1.318M5.711 15.033l.772 1.162M4.112 16.39l.117 1.942M4.112 16.39l-.561.74M4.112 16.39l-.788-1.615M4.112 16.39l-.031-1.685M3.824 13.668l.257 1.037M3.824 13.668l.998.226M5.5 13.863l-.678.031M5.5 13.862l.929-.592"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.5 13.863.211 1.17M6.53 14.159l.094 1.014M7.294 12.599l.14-.616M7.294 12.599l-.101.67M6.99 13.816l.203-.546M6.99 13.816l.554.234"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.152 14.338-.608.367M8.051 12.085l-.413-.312M8.051 12.084l-.445.468M8.113 12.794l-.507-.242M6.912 12.334l-.483.296M6.912 12.334l-.008.936"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M7.193 13.27h-.289M7.193 13.27h.374"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.113 12.794-.546.476M8.137 13.558l-.57-.288M8.137 13.558l-.593.476"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.152 14.338.671.258"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.205 14.315-.382.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.37 13.676-.594.273"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.205 14.315-.429-.367"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.152 14.338.624-.39M8.113 12.794l.617.421"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.104 12.958-.374.257M9.104 12.958l-.491-.515"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.613 12.443.117.773M8.613 12.443l-.5.351M8.613 12.443l-.562-.359M8.613 12.443l-.156-.67M8.613 12.443l.273-.039M8.457 11.773l-.406.312M8.776 13.949l-.046-.734"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.37 13.676-.64-.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.137 13.559.593-.344M8.137 13.558l.64.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.152 14.338-.608-.304"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m7.037 14.565.507-.515"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m7.037 14.565-.054.483"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m7.037 14.565-.413.608M7.037 14.565l-.047-.75M4.962 12.716l.75.647M5.906 12.435l-.195.928M6.429 12.63l-.718.734M5.5 13.862l.929-.592M5.5 13.863l.211-.5M6.429 13.27l-.718.093M6.429 13.27l.483-.936M6.429 13.27h.475M6.53 14.159l.374-.89M6.53 14.16l.46-.344"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.53 14.159-.819.873M6.53 14.159l-.101-.89M3.122 13.496l.202 1.28M3.824 13.668l-.702-.172M3.824 13.668l-.601-1.412M3.824 13.668l.335-1.163M3.387 10.43l-.258.204M3.387 10.43 2.895 9.8M3.387 10.43l.398-.631M3.387 10.43l.53-.038M2.747 11.117l.382-.484M3.387 10.43l.203.383"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.43 9.378.765.702M6.733 9.65l-.538.43M6.733 9.65l.538.984M8.137 9.94l-.866.694"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M8.137 9.94 6.343 8.722"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.137 9.94 1.396-1.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M8.137 9.94 8.05 7.395"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M8.051 7.396 6.343 8.722M6.234 7.537l.109 1.186"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.5 8.184.843.538M5.5 8.184l-.07 1.193M5.5 8.184l.734-.647M8.137 9.94l-.086 1.138"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.137 9.94.749.694M8.581 10.922l.305-.289M9.307 9.667l-.421.967"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.673 10.228-.787.406M9.627 10.72l-.741-.087M10.672 10.43l1.31-.117M9.627 10.72l1.045-.29M9.993 11.016l.679-.585M9.993 11.016l-.366-.297"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.993 11.016-.46.273"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.424 11.312.203-.593"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.018 11.016.609-.297"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.673 10.228.999.203M11.343 9.635l-.671.796"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.343 9.635.64.679M12.622 9.814l-.64.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.673 10.228-.366-.562"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.533 8.56-.226 1.107M9.533 8.559l.46-1.022M10.102 9.386l-.109-1.849"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.012 5.15 1.981 2.387"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.012 5.15 1.817.89M9.83 6.04l.163 1.497M9.83 6.04l.03-1.327M11.28 5.29l-1.42-.577"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M11.28 5.291 9.993 7.537"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.92 6.92-1.927.617M11.842 7.396l-1.849.14M11.842 7.396l-1.116.804M11.842 7.396l.507 1.436M12.715 8.13l-.366.701M12.715 8.13l.515.67M12.715 8.13l.18 1.333M12.715 8.13l.437-.663M13.714 7.31l-.562.157M13.199 6.546l.515.765M13.542 8.715l.172-1.404M13.542 8.715l-.39-1.248M11.842 7.396l1.31.07M10.726 8.2l1.623.631M11.343 9.635l1.006-.803M12.622 9.814l-.273-.982M12.895 9.463l-.546-.631M11.28 5.291l-1.45.749M11.592 4.534l-1.731.18M9.79 3.387l.07 1.326M9.79 3.387l-1.84-.179M9.86 4.713 7.95 3.208M9.79 3.387l-.163-.928M7.95 3.208l1.677-.749M8.012 1.96l1.615.5M8.028 1.671l1.599.788M9.884 2.015l-.257.445M10.188 2.163l-.561.296M10.648 2.865l-1.021-.406M10.649 2.865l1.193.632"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.188 2.163 1.654 1.334"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.663 2.865.179.632M12.481 3.746l-.64-.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.188 2.163.46.702M9.79 3.387l.859-.522M7.95 3.209l-1.576-.741M6.078 3.388l.296-.92M5.43 2.841 4.253 4.666M5.43 2.841l-1.279.671M6.023 4.502l-1.77.164"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.078 3.387-1.825 1.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.43 2.842.944-.374"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.43 2.841.648.546M7.95 3.208l-1.872.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M7.95 3.208 6.023 4.503"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m7.95 3.208.062 1.942M6.023 4.502l1.989.648M5.524 2.304l.85.163"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.14 2.07.234.397M8.028 1.671l-1.654.796M8.012 1.96l-1.638.507M8.012 1.96 7.95 3.208M11.592 4.534 9.79 3.387M11.592 4.534l.25-1.037M12.832 5.29l-.99-1.793M12.832 5.29l-1.24-.756M11.28 5.29l.312-.756M11.28 5.291h1.552"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.982 5.291.616 1.256"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.28 5.291 1.318 1.256M11.92 6.92l.678-.374M12.286 7.42l.312-.874M12.286 7.42l.43.71M13.144 7.467l-.546-.92M12.598 6.546h.6M13.144 7.467l.055-.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m12.832 5.291.367 1.256M12.832 5.291l.546.749"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m12.832 5.291-.234 1.256M12.832 5.29l.226-.577"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.842 3.497 1.217 1.216M13.378 6.04l-.32-1.327M13.628 6.04l-.57-1.327M12.903 4.105l.156.609"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.012 5.15 1.849-.437M10.726 8.2l-.733-.663M8.051 7.396l1.942.14M10.726 8.2l-.624 1.185M10.726 8.2l.617 1.435"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.673 10.228.43-.843M10.672 10.43l-.57-1.045"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00522A",
    d: "M11.662 11.663a3.2 3.2 0 0 1-.897.015l-.039.102s.297.015.702 0l.234-.11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.042,
    d: "M11.842 11.773s-.18.335-.304.335"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.405 16.624-.273.67M6.405 16.624l-.81.148M5.313 17.466l.281-.694M5.313 17.466l.102.546"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.03 17.91-.615.102M6.03 17.91l-.717-.444M5.18 18.636l.235-.624M4.994 17.942l.42.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.994 17.942.187.694M5.766 19.143l-.585-.507"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.766 19.143.42.328M5.844 20.086l.343-.616M6.452 20.133l-.265-.663"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.452 20.134.117-.718"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.928 20.087-.359-.671"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.928 20.087-.476.047M6.928 20.087v.46M7.599 20.391l-.671.156M7.599 20.391l-.671-.304M6.96 19.354l-.032.733"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m7.513 19.97-.585.117"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.959 19.354.554.616"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.168 19.526-.655.445"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m7.599 20.39-.086-.42M7.599 20.391l.569-.367M7.599 20.391l.538.312M8.168 20.024l-.031.679M8.706 20.47l-.57.233M8.706 20.469l-.538-.445M8.706 20.469l-.039-.5M8.706 20.469l.46-.562M8.706 20.47l.71.147M8.745 21.062l.671-.445M9.517 20.984l-.1-.367M9.868 20.47l-.452.147M9.868 20.47l-.093-.531M9.868 20.47l.414-.095M10.305 20.547l-.023-.172M10.305 20.547l-.42.18M10.305 20.547l.585-.577M11.397 19.416l-.507.554M10.812 19.666l.078.304M9.868 20.47l.016.257M9.416 20.617l.468.11M8.745 21.062l-.039-.593M8.745 21.062l-.608.078"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.167 19.907.25.71M9.775 19.939l-.359.678"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.452 20.134-.608-.047"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.844 20.087-.078-.944M5.766 19.143l-.453.18M5.18 18.636l.133.687"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.744 16.467-.289 1.514M4.994 17.942l-.539.039"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.405 16.624.328.67M6.982 16.561l-.25.733"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M8.012 5.197a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003D1C",
    d: "M7.95 3.224a.016.016 0 1 0 0-.031.016.016 0 0 0 0 .031"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M2.318 9.198a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M2.895 9.846a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M3.122 9.308a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M3.925 8.739a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M4.073 7.904a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M3.504 7.584a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M9.673 10.275a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M8.886 10.665a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M8.137 9.986a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M6.733 9.682a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M6.195 10.127a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M5.43 9.424a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M5.5 8.231a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M4.79 7.506a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M4.12 6.725a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M2.927 6.6a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .094M3.223 6.983a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M3.457 6.187a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.145 5.65a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .093M3.761 5.415a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M2.583 6.102a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M2.482 6.827a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M2.435 7.802a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M2.973 7.927a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.176 8.59a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M4.416 9.276a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.098 4.76a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M4.253 4.698a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M4.814 5.462a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M6.023 4.534a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M5.43 5.096a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M6.078 5.376a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M6.57 19.448a.031.031 0 1 0-.001-.063.031.031 0 0 0 0 .063M6.96 19.385a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M6.187 19.517a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M5.766 19.175a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M5.844 20.134a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M12.216 21.678a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M15.149 23.261a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M13.605 24.244a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M5.18 18.667a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M6.03 17.942a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.168 17.825.57-.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.221 17.731-.484-.366"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.221 17.731-1.053.094M8.784 18.402l-.593.593M9.042 18.855l-.85.14M9.042 18.854l.491-.203M8.784 18.402l.258.452M9.299 18.324l-.257.53M9.299 18.324l.234.328M9.712 18.277l-.179.375M9.712 18.277l.305.125M10.142 18.168l-.125.234M10.469 18.371l-.452.031M9.533 18.652l.484-.25M9.221 17.731l.04-.476M9.221 17.732l.53-.5M9.853 17.732l-.102-.5M9.853 17.731l.39-.476M9.853 17.731l.717.164M10.243 17.255l.327.64M11.054 17.42l-.484.475M11.32 17.927l-.75-.032M11.32 17.926l-.266-.507M11.32 17.926l.155-.74M11.32 17.926l.771-.429M11.499 18.324l.592-.827"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m13.316 16.819-.6-.04M12.091 17.497l.203-.717M11.998 18.59l1.318-1.771"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.998 18.59.093-1.093M12.715 16.78l-.624.717M12.715 16.78l.32-1.045M12.294 16.78l.741-1.045M12.091 15.782l.944-.047M12.294 16.78l-.203-.998M11.686 16.453l.405-.671M11.42 15.306l.671.476"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.47 14.362.913.413M9.712 15.002l.671-.227"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.095 14.034-.422-.585M10.68 13.894l-1.007-.445"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.095 14.034.288.741"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.47 14.362.625-.328M10.68 13.894l-.585.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.68 13.894-.297.881M11.015 14.486l-.632.289M10.243 15.509l.14-.734M11.42 15.306l-1.037-.53"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.095 16.273.148-.765M9.658 16.164l.585-.656M9.658 16.163l-.476-.148M9.658 16.164l.437.109"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.658 16.164.054.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.26 17.256.453-.632M9.752 17.232l-.04-.608"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M9.221 16.624h.491M10.134 16.679l-.421-.055M10.134 16.678l.78.172"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.812 16.35-.717-.078"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.134 16.678-.04-.405"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.812 16.35.609-1.044"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.135 15.813.047.202M9.4 15.75l.843-.242M11.42 15.306l-1.177.203"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.42 15.306.812-.741M12.091 15.781l.14-1.216M12.95 14.728l-.718-.163M12.091 15.782l.858-1.053M13.527 14.705l-.578.024M13.27 14.019l-.32.71M13.27 14.019l.257.686M13.644 13.972l-.117.733M13.644 13.972l-.016-1.139M12.598 13.777l-.179-1.1M12.598 13.777l-.78-1.21M12.598 13.776l.351.952M13.527 14.705l-.492 1.03M13.675 14.978l-.149-.273M13.675 14.978l-.359 1.84"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m12.091 17.497.476.328M12.614 18.2l-.047-.375"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m12.614 18.2.702-1.381M12.614 18.2l-1.217 1.216M12.403 18.41l.133 1.279M12.31 20.672l.226-.983M12.31 20.672l.358 1.124M12.31 20.672l-.094.975M12.669 21.795l-.453-.149M12.263 22.497l-.047-.85M12.669 21.795l-.406.702M12.98 22.022l-.717.475M12.396 23.846l-.133-1.35M12.396 23.846l1.208.367"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m12.396 23.846.272.843"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m13.527 21.99.592.756M13.285 22.59l.834.157"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m13.285 22.59-.46.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m15.149 23.23-1.03-.483M11.857 21.04l.36.607M11.35 21.764l.866-.117M11.35 21.764l-.935.866M10.477 22.115l-.062.515M10.477 22.115l.873-.741M11.35 21.764l-.054.78M12.263 22.497l-.967.046M12.263 22.497l-.92.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.461 23.41.882-.203"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.25 23.862.093-.655M11.25 23.862l1.013-1.365"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85FFB6",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.25 23.862-.789-.452"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.249 23.862.117.827"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.249 23.862-1.724 1.412"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.972 23.846-.85-.359M8.971 23.846l-.046-.803M9.556 23.066l-.631-.023M9.556 23.066l-.585.78M10.461 23.41l-1.49.436"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.461 23.41-.905-.344"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.461 23.41-.046-.78M9.556 23.067l.858-.437M8.137 22.926l.788.117M8.137 22.926l.694-.585M9.463 21.608l-.632.733"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.463 21.608.094 1.459"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.831 22.341.725.726M8.121 23.488l.804-.445"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.971 23.846-.85.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.971 23.846-.32 1.069"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.971 23.846.554 1.428M11.296 22.544l.047.662M11.296 22.544l-.835.865M10.415 22.63l.88-.086M11.857 21.04l-.507.724M11.857 21.04l-.507.334M11.857 21.039l-.07-.523M12.162 19.61l-.375.906M12.162 19.61l.374.079M12.162 19.61l.241-1.2M11.608 19.65l.795-1.24M11.608 19.65l-.46.609M10.531 20.953l.617-.694M10.531 20.953l-1.068.655M10.414 22.63l-.951-1.022M12.31 20.672l-.453.367M11.304 19.213l.093.203M11.998 18.59l-.694.623M11.32 17.926l.178.398M11.32 17.926l-.851.445M11.054 18.504l-.585-.133M10.453 18.995l.016-.624M10.048 18.738l.421-.367M11.054 18.504l.445-.18M11.304 19.213l.195-.889M10.57 17.896l-.101.475M10.141 17.926l.328.445M9.221 17.731h.632"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M10.57 17.926a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M13.035 15.766a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M10.243 15.54a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M11.054 18.535a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M11.475 17.232a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M11.32 17.973a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M10.469 18.418a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M12.091 17.544a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M11.499 18.355a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M11.998 18.637a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M12.091 15.829a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M11.686 16.499a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M11.42 15.352a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M10.391 14.822a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M10.68 13.94a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M12.95 14.775a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m3.847 22.458-.125 1.388M3.847 22.458l1.022 1.42M4.76 23.222l.109.655"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.822 24.696.047-.819"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M6.631 25.305 4.87 23.877"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m6.632 25.305.514-1.506M7.59 25.04l-.444-1.24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.121 23.916-.975-.117M5.657 23.394l1.49.406"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#85FFB6",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.656 23.394-.787.484"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.76 23.222.897.172"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.76 23.222.897.172"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.76 23.222.062-.663M4.76 23.222l-.913-.764M3.847 22.458l-.296-.803M4.3 21.054l1.2.834M5.345 21.358l.155.53M5.345 21.358l.257-.405M5.345 21.358l-.188-.164M4.908 21.483l.25-.289M5.033 20.648l.124.546M5.033 20.649l.179-.234M5.033 20.648l-1.225-1.934M4.767 20.843l-.959-2.13M4.908 21.483l-.18.203M4.3 21.062l.428.624M4.3 21.062l-.305.593M3.847 20.266l.094.304M4.034 19.416l.078.546M4.034 19.416l-.343-1.084M5.602 20.953l-1.91-2.621M4.034 19.416l.398 1.03M4.3 21.062l.132-.617M4.3 21.062l-.36-.492M3.995 21.655l-.054-1.085M3.995 21.655h-.444M3.995 21.655l-.148.803"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m1.99 22.739-.6.288"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m1.99 22.739.82-.133M2.607 22.005l.203.601M3.145 22.052l-.335.554M3.995 21.655l.733.031M4.822 22.56l-.827-.905M4.822 22.56l-.094-.874"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.75 22.606-.093.788"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.75 22.606.82.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.657 23.394.912-.328M8.121 23.488l-.928-.476M7.146 23.8l.975-.313M7.146 23.8l.047-.788"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m7.146 23.8-.577-.734M7.193 23.012l-.624.054M5.75 22.606l-.928-.047M5.75 22.606l-1.022-.92M5.5 21.888l-.772-.203M5.5 21.889l.57.452"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.822 22.56.834.834"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M5.657 23.44a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .094M4.822 22.606a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M10.461 23.456a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M11.296 22.59a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M12.263 22.544a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M12.396 23.893a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M13.285 22.622a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M14.12 22.793a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M11.249 23.893a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M8.972 23.893a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M8.121 23.519a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M8.925 23.074a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M8.137 22.957a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M9.557 23.098a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M10.414 22.66a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .063M5.5 21.92a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M4.728 21.717a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M5.75 22.638a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M6.57 23.113a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M4.869 23.924a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.722 23.877a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M3.847 22.505a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M3.995 21.686a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M2.81 22.638a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M1.99 22.77a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.65 19.642-.538.32M4.112 19.962l-.171.608M4.432 20.446l.429-.507M5.89 21.584l-.413-.444M5.89 21.584l-.288-.631"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.602 20.953.491.28M5.89 21.584l.508.304M5.89 21.584l.18.757"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m5.89 21.584.203-.35M6.398 21.889l-.305-.656M6.538 21.569l-.445-.336M5.711 20.812l.382.421M5.711 20.813l-1.42-1.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M4.822 13.94a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M4.081 14.752a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m3.824 13.668-.5 1.107"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M4.994 15.048a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M5.711 15.08a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .093M5.5 13.91a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .093M6.53 14.205a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M6.429 13.317a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M5.711 13.41a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M6.99 13.863a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M7.544 14.08a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .094M13.152 7.514a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M11.842 7.428a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M12.895 9.51a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .094M12.715 8.176a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.102 11.196-.109-.18"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.042,
    d: "M10.461 11.101s.64-.171 1.225.047"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.415 12.084.444.031M10.415 12.084l.561.32M11.538 13.114l-.562-.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.414 12.084-.296.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "M10.859 12.116h.679M10.095 11.648l.32.436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M10.976 12.45a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .094"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.726 11.773.133.343M11.218 11.78l-.359.335M11.218 11.78l.32.335M13.714 9.635l.327.102M13.714 9.635l-.172-.92M13.714 9.635l-.367.18M13.23 8.8l.117 1.014M13.23 8.8l.312-.085M13.41 10.478l.467-.101M12.871 11.468l.538-.99M12.871 11.468l-.156-.6M12.497 11.702l-.242-.296M13.41 10.478v1.06M13.113 11.023l.297.515M13.113 11.024l-.164-1.21M12.708 10.33l.241-.516M13.113 11.024l.234-1.21M13.714 9.635l-.304.843"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m4.767 20.843.266-.195M5.033 20.648l.444.492M4.767 20.843l.39.351M4.767 20.843l-.335-.398M4.112 19.962l.32.483M4.112 19.962l-.398-1.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m3.691 18.332-.234 1.903.39.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M11.538 13.16a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .094M12.598 13.824a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M12.232 14.611a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M13.27 14.065a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M13.542 8.762a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M8.051 7.443a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M6.429 12.661a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M6.483 16.226a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M4.455 18.012a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062M5.423 18.043a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M5.906 12.467a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M4.962 12.685c.016 0 .032.016.032.031a.034.034 0 0 1-.032.032.034.034 0 0 1-.03-.032c0-.015.015-.03.03-.03M6.405 16.67a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .094M6.982 16.608a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M5.313 16.515a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M5.844 16.397a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M4.744 16.515a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M4.112 16.436a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.324 14.822a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.824 13.714a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.122 13.543a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M3.223 12.303a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M4.159 12.552a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M7.193 13.317a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.338 11.967.78.617"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.338 11.967.21.944"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.923 13.239.195-.655M9.923 13.238l.975-.062"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M10.898 13.215a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M7.568 13.317a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M7.59 12.591a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.052,
    d: "M4.533 11.374s.375.28 1.069.273M1.453 11.983s.405-.484.662.35"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33FF85",
    d: "m9.47 14.362.242.64-.507-.687.164-.304z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00E05A",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.206 14.315.507.686"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.463 21.608-.718-.546M10.329 20.703l2.074-2.293M10.329 20.703l-.812.28M8.745 21.061l.772-.078"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.052,
    d: "m10.305 20.547.024.156.202.25-.054 1.162"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.329 20.703-.866.905M11.787 20.516l-1.778 1.661"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.052,
    d: "m10.96 20.921 1.17-1.708.273-.803"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.812 20.633.148.289.39.452M10.89 19.97l.538.873"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33FF85",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m10.96 20.921-1.185 1.007"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.137 21.538 1.326.07"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.137 21.943 1.326-.335M10.009 22.177l-1.178.164"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m9.775 21.928-.944.413M8.137 22.2l.694.141"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M8.831 22.373a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M3.94 20.602a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A341",
    d: "m4.23 18.332-.773-.21.866.834z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00E05A",
    d: "m5.212 19.751-1.755-1.63 2.324 2.527.016-.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M3.13 10.68a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M2.747 11.164a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M3.387 10.477a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.917 10.438a.047.047 0 1 0 0-.093.047.047 0 0 0 0 .093M3.59 10.86a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M3.785 9.846a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M6.343 8.77a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .093M6.234 7.584a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .094M7.146 23.847a.047.047 0 1 0 0-.094.047.047 0 0 0 0 .093M7.193 23.043a.031.031 0 1 0 0-.063.031.031 0 0 0 0 .063M6.866 22.528a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m8.137 21.14.983.21 1.209-.647M11.857 21.039l.679-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.787 20.516.343-1.303M11.428 20.843l.43.195M11.233 20.532l.554-.016M12.536 19.69l-.749.826"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5CFF9D",
    d: "M4.151 3.543a.031.031 0 1 0 0-.062.031.031 0 0 0 0 .062"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m12.918 11.936.71.897"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m12.419 12.677-.39-.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003D1C",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m12.419 12.677.702.359M12.918 11.936l.203 1.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00A341",
    strokeMiterlimit: 10,
    strokeWidth: 0.062,
    d: "m11.818 12.568-.241-.351M11.818 12.568l.601.11M12.918 11.936l-.499.741"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-head-green_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h16v25H0z"
  })))));
};
export default SvgLogoHeadGreen;